package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ModerationLogEntry(
    val id: String,
    @SerialName("admin_name") val adminName: String?,
    val action: String,
    @SerialName("target_user_id") val targetUserId: String?,
    @SerialName("target_user_name") val targetUserName: String?,
    @SerialName("target_listing_id") val targetListingId: String?,
    @SerialName("target_listing_title") val targetListingTitle: String?,
    val reason: String?,
    @SerialName("created_at") val createdAt: String
)
